import { render } from "./IconFinanceReports.vue?vue&type=template&id=474abc8e"
import script from "./IconFinanceReports.vue?vue&type=script&lang=js"
export * from "./IconFinanceReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__